import '../../App.point.css';
import React, { Component } from 'react';
import fn_set_footer from './StdtMenuCmp';
import $ from 'jquery';
import { udfAutoLogin, url, udfInlineLoading, udfNoneLoading, setStdtInfo, AlertModal, udfLogOut, openAlert } from '../../common/common';
import loader from '../../imgs/ajax-loader.gif';
import { Navbar, Tabs, Tab, ListGroup, Form, ButtonToolbar, ToggleButtonGroup, ToggleButton } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowCircleLeft, faAssistiveListeningSystems, faAngleRight } from '@fortawesome/free-solid-svg-icons';

const errMsg = '조회 도중 오류가 발생했습니다. 다시 시도해주세요.';

let firstIndex = 0;	// 불러 올 시작 레코드
const recordCountPerPage = 10;	// 한번에 불러 올 레코드 개수
let isMore = true;	// 불러 올 레코드 존재 여부
let isRunning = false;
let isLogging = false;

const defaultOrder = 'RL_DATE';
let selectKind = '';
let selectOrder = '';

let selectBtn = '';

class RuleListCmp extends Component {
  constructor(props) {
    super(props);

    this.state = {

      // bootstrap Alert 변수
      alertShow: false,
      alertClickNo: null,
      alertClickYes: null,
      alertClickOk: null,
      alertMessage: null,

      HAKGWA: '',
      GRADE: '',
      BAN: '',
      BUN: '',
      STD_NM: '',
      HP_STD: '',
      HP_PRT: '',
      HP_PRT2: '',
      PREV_POINT: '',
      POINT_B: '',
      POINT_R: '',
      POINT_G: '',
      POINT_S: '',
      POINT_RATING: '',
      RATING_GU_NM: '',
      ruleList: [],
      jcList: [],
      isLoggedIn: null,

      BBS_YN: '',
      usrInfo: null,
      clGuNm: { B: '상점', R: '벌점', G: '회복', S: '차감' },
    };
  }

  componentDidMount = () => {
    if (this.state.ruleList.length === 0) {
      isMore = true;
      isRunning = false;
      firstIndex = 0;
      selectKind = '';
      selectOrder = '';
      selectBtn = '';
    }

    window.addEventListener('scroll', this.handleScroll);

    // 로그아웃 버튼 바인딩
    document.getElementById("logoutBtn").addEventListener('click', () => { udfLogOut(this) });
    // 뒤로 이동 버튼 바인딩
    $('.goBackBtn').on('click', () => {
      if (this.props.history !== null && typeof (this.props.history) !== undefined) this.props.history.go(-1);
    });

    if (!isRunning && !isLogging) {
      isLogging = true;
      const that = this;
      // 자동 로그인 체크
      udfAutoLogin(this).then((data) => {
        isRunning = false;
        isLogging = false;
        if (data !== null && data.userSe === 'STDT' && data.STD_CD !== '') {
          this.setState({ usrInfo: data, clGuNm: { B: data.BLUE_NM, R: data.RED_NM, G: '회복', S: '차감' } });
          if (!data.AUTH_CFM_DATE && !localStorage.SCHOOL_AUTH_EMAIL_POP) {
            openAlert(that, '** 이메일 인증 등록 안내 **\n\n이메일 인증을 사용하면 비밀번호를 분실하거나 도난당한 경우에도 계정을 더 안전하게 보호 할 수 있습니다.\n\n아래 [내정보] 메뉴에서 이메일 인증 등록을 확인해 주세요. (선택사항)');
            localStorage.setItem('SCHOOL_AUTH_EMAIL_POP', 'Y');
          }
          $("#ruleTabs-tab-rule").text((this.state.usrInfo ? this.state.usrInfo.BLUE_NM : '상점') + "/" + (this.state.usrInfo ? this.state.usrInfo.RED_NM : '벌점') + " >");
          this.udfSelectStdtRuleHistory();
        } else if (data !== null && data.userSe === 'STDT' && data.STD_CD === '') {
          this.props.history.push('/joinStdt');
        } else if (data !== null && data.userSe === 'USR') {
          this.props.history.push('/menuList');
        } else {
          this.props.history.push('/');
        }
      });
    }

  }

  componentWillUpdate = () => {
    $('a[role="tab"]').addClass('col text-center pl-2 pr-2');
  }

  componentWillUnmount = () => {
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll = () => {
    if ($('.wrap-loading').length - $('.wrap-loading.d-none').length !== 0 || $('.modal-backdrop.show').length > 0)
      return false;

    let marginBottom = 71;
    if (window.innerHeight + marginBottom >= Math.ceil(document.getElementsByTagName('body')[0].getBoundingClientRect().bottom) && isMore) {
      this.udfSelectStdtRuleList(null, null, 'N');
    }
  }

  udfSelectStdtRuleHistory = () => {
    if (!this.state.usrInfo || isLogging) return;

    udfInlineLoading();
    const that = this;

    $.ajax({
      url: url + '/slp/stdt/selectStdtRuleHistoryJSON.do?isMobile=Y',
      type: 'GET',
      dataType: 'jsonp',
      success: function (data) {
        udfNoneLoading();

        if (!data.success)
          that.componentDidMount();
        else {

          if (data.stdtInfo !== undefined && data.stdtInfo !== null) {
            that.udfSelectStdtRuleList('', defaultOrder);

            setStdtInfo(data.stdtInfo);

            that.setState({
              RATING_GU_NM: data.RATING_GU_NM,
              HAKGWA: data.stdtInfo.HAKGWA,
              GRADE: data.stdtInfo.GRADE,
              BAN: data.stdtInfo.BAN,
              BUN: data.stdtInfo.BUN,
              STD_NM: data.stdtInfo.STD_NM,
              HP_STD: data.stdtInfo.HP_STD,
              HP_PRT: data.stdtInfo.HP_PRT,
              HP_PRT2: data.stdtInfo.HP_PRT2,
              PREV_POINT: data.stdtInfo.PREV_POINT,
              POINT_B: data.stdtInfo.POINT_B,
              POINT_R: data.stdtInfo.POINT_R,
              POINT_G: data.stdtInfo.POINT_G,
              POINT_S: data.stdtInfo.POINT_S,
              POINT_RATING: data.stdtInfo.POINT_RATING,
              isLoggedIn: true,
              BBS_YN: data.BBS_YN,
            });
          } else
            openAlert(that, that.errMsg);

          that.setState({
            isLoggedIn: true,
          });
        }
      },
      error: function (jqXHR, status, error) {
        isRunning = false;
        that.componentDidMount();
        udfNoneLoading();
      }
    });
  }

  udfSelectStdtRuleList = (kind, order, clearYn) => {
    if (kind === null) kind = selectKind;
    if (order === null) order = selectOrder;

    selectKind = kind;
    selectOrder = order;

    if (clearYn === 'Y') {
      firstIndex = 0;
      isMore = true;
      if (selectKind !== 'JC') selectBtn = selectKind;

      $.each($('button[name=btn]'), function (idx, obj) {
        $(obj).removeClass('active');
        if ($(obj).attr('id') === 'btn-' + selectKind)
          $(obj).addClass('active');
      });
    }

    let that = this;
    let data = {
      isMobile: 'Y',
      SF_KIND: kind,
      SF_ORDER: order === 'none' ? '' : order,
      firstIndex: firstIndex,
      recordCountPerPage: recordCountPerPage,
    };

    if (isMore && !isRunning) {
      udfInlineLoading();
      isRunning = true;

      $.ajax({
        url: url + '/slp/stdt/selectStdtRuleListJSON.do',
        type: 'GET',
        dataType: 'jsonp',
        data: data,
        success: function (data) {
          udfNoneLoading();

          if (!data.success)
            that.componentDidMount();
          else {
            if (data.login === '0') {
              that.setState({
                isLoggedIn: false
              });
            } else {
              let ruleList = [];
              let jcList = [];

              if (data.list !== undefined && data.list !== null) {
                var idx = firstIndex;
                $.each(data.list, function (i, val) {
                  idx++;

                  if (selectKind !== 'JC') {
                    // 상/벌점
                    ruleList.push({
                      CL_GU: val.CL_GU,
                      POINT_GU: that.state.clGuNm[val.CL_GU],
                      CL_NM: val.CL_NM,
                      RL_DATE: val.RL_DATE,
                      RL_TIME: val.RL_TIME,
                      RL_DESC: val.RL_DESC,
                      ESNTL_NM: val.ESNTL_NM,
                      JG_DATE: val.JG_DATE,
                      POINT: val.POINT
                    });
                  } else {
                    // 지도/상담
                    jcList.push({
                      CNSL_DESC: val.CNSL_DESC,
                      ESNTL_NM: val.ESNTL_NM,
                      JG_APLY_YN: val.JG_APLY_YN,
                      JG_DATE: val.JG_DATE,
                      JG_DESC: val.JG_DESC,
                      JG_EDATE: val.JG_EDATE,
                      JG_POINT: val.JG_POINT,
                      JG_SDATE: val.JG_SDATE,
                      JG_TIME: val.JG_TIME
                    });
                  }
                });

                if (idx - firstIndex !== recordCountPerPage) isMore = false;
                firstIndex += recordCountPerPage;

                if (selectKind !== 'JC') {
                  if (clearYn !== 'Y') ruleList = that.state.ruleList.concat(ruleList);

                  that.setState({
                    ruleList: ruleList,
                    isLoggedIn: true,
                  });
                } else {
                  if (clearYn !== 'Y') jcList = that.state.jcList.concat(jcList);

                  that.setState({
                    jcList: jcList,
                    isLoggedIn: true,
                  });
                }
              } else {
                openAlert(that, errMsg);
                that.setState({
                  isLoggedIn: true,
                });
              }
            }
          }
          isRunning = false;
        },
        error: function (jqXHR, status, error) {
          udfNoneLoading();
          isRunning = false;
          that.componentDidMount();
        }
      });
    }
  }

  handleSelect = (key) => {
    if (key === 'rule') this.udfSelectStdtRuleList(selectBtn, null, 'Y');
    else this.udfSelectStdtRuleList('JC', null, 'Y');
  }

  render() {
    const { ruleList, jcList } = this.state;
    const setRuleList = ruleList === null || ruleList.length === 0 ?
      <>
        <div className='row ruleRow mt-4'>
          <div className='col'>조회된 데이터가 없습니다</div>
        </div>
      </> :
      ruleList.map((data, idx) => (
        <div key={idx} className='row ruleRow'>
          <div className='pl-0 col-2'><span className={data.POINT_GU === this.state.usrInfo.BLUE_NM ? 'blue-point' : data.POINT_GU === this.state.usrInfo.RED_NM ? 'red-point' : data.POINT_GU === '회복' ? 'green-point' : data.POINT_GU === '차감' ? 'deduction-point' : ''}>{data.POINT_GU}</span></div>
          <div className='col' style={{ paddingLeft: '0' }}>
            <div className='font-weight-bold'>{data.RL_DATE} {data.RL_TIME}</div>
            <div>{data.RL_DESC}</div>
            <div>
              <span style={{ float: 'left' }}>교사: {data.ESNTL_NM}</span>
              {
                this.state.usrInfo && this.state.usrInfo.RATING_GU !== "Z" ?
                  <span className='point'>{data.POINT} 점</span>
                  : ""
              }
            </div>
          </div>
        </div>
      ));
    const setJcList = jcList === null || jcList.length === 0 ?
      <>
        <div className='row ruleRow mt-4'>
          <div className='col'>조회된 데이터가 없습니다</div>
        </div>
      </> :
      jcList.map((data, idx) => (
        <div key={idx} className='row ruleRow mt-4'>
          <div className='col-2'>
            <span className="green-point">
              <FontAwesomeIcon icon={faAssistiveListeningSystems} />
            </span>
          </div>
          <div className='col'>
            <div className="font-weight-bold">{data.JG_DATE} {data.JG_TIME}</div>
            <dl>
              <dt className="font-weight-normal"><FontAwesomeIcon icon={faAngleRight} /> 상담내용</dt>
              <dd className="pl-4">{data.CNSL_DESC}</dd>
              <dt className="font-weight-normal"><FontAwesomeIcon icon={faAngleRight} /> 지도내용</dt>
              <dd className="pl-4">{data.JG_DESC}</dd>
              <dt className="font-weight-normal"><FontAwesomeIcon icon={faAngleRight} /> 지도기간</dt>
              <dd className="pl-4">{data.JG_SDATE} {data.JG_EDATE !== '' ? '~ ' + data.JG_EDATE : ''}</dd>
              {
                this.state.usrInfo && this.state.usrInfo.RATING_GU !== "Z" ?
                  <>
                    <dt className="font-weight-normal"><FontAwesomeIcon icon={faAngleRight} /> 지도차감점수</dt>
                    <dd className="pl-4"><span className="point" style={{ float: 'unset' }}>{data.JG_POINT} 점</span>, {data.JG_APLY_YN === 'Y' ? '차감 적용' : '차감 미적용'}</dd>
                  </>
                  : ""
              }
            </dl>
            <div>
              <span style={{ float: 'left' }}>교사: {data.ESNTL_NM}</span>
            </div>
          </div>
        </div>
      ));

    return (
      <>
        <AlertModal
          show={this.state.alertShow}
          onHide={this.alertClose}
          Title="스쿨라이프"
          Message={this.state.alertMessage}
          onClickOk={this.state.alertClickOk}
          onClickNo={this.state.alertClickNo}
          onClickYes={this.state.alertClickYes}
        />

        {/* loading image */}
        <div className="wrap-loading">
          <img src={loader} alt="로딩 이미지" />
        </div>

        {/* header */}
        <Navbar fixed="top" className="title">
          <div className="goBackBtn"><div style={{ color: '#fff' }}><FontAwesomeIcon icon={faArrowCircleLeft} className="btn-home" /></div></div>
          {this.state.usrInfo ? this.state.usrInfo.BLUE_NM : '상점'}/{this.state.usrInfo ? this.state.usrInfo.RED_NM : ' 벌점'} 내역
        </Navbar>

        {/* 학생 정보
        <div className='stdtInfo' style={{ marginTop: '3.4rem' }}>
          <FontAwesomeIcon icon={faUserGraduate} style={{ paddingRight: '5px' }} />
          {this.state.HAKGWA}{this.state.HAKGWA !== '' ? ' ': ''}{this.state.GRADE}학년 {this.state.BAN}반 {this.state.BUN}번 {this.state.STD_NM}
        </div> */}

        <div className='container-fluid noScroll' style={{ marginBottom: '71px', marginTop: '3.8rem' }}>

          <Tabs defaultActiveKey='rule' id='ruleTabs' onSelect={(key) => { this.handleSelect(key) }}>
            <Tab eventKey='rule' title='상점/벌점 >'>
              {
                this.state.usrInfo && this.state.usrInfo.RATING_GU !== "Z" ?
                  <Form className='mt-2 mb-4 searchRuleGu'>
                    <div className="d-flex flex-column">
                      <ButtonToolbar>
                        <ToggleButtonGroup type="radio" name="options1" defaultValue={['RL_DATE']} style={{ width: '100%' }} >
                          <ToggleButton variant="light" className="col" value={'RL_DATE'} onClick={() => { this.udfSelectStdtRuleList(null, 'RL_DATE', 'Y') }}>최신순</ToggleButton>
                          <ToggleButton variant="light" className="col" value={'none'} onClick={() => { this.udfSelectStdtRuleList(null, 'none', 'Y') }}>과거순</ToggleButton>
                        </ToggleButtonGroup>
                      </ButtonToolbar>
                    </div>
                    <ButtonToolbar className="mt-1">
                      <ToggleButtonGroup type="radio" name="options1" defaultValue={['']} style={{ width: '100%' }}>
                        <ToggleButton variant="light" className="col" value={''} onClick={() => { this.udfSelectStdtRuleList('', null, 'Y') }}>전체</ToggleButton>
                        <ToggleButton variant="light" className="col" value={'B'} onClick={() => { this.udfSelectStdtRuleList('B', null, 'Y') }}>{this.state.usrInfo ? this.state.usrInfo.BLUE_NM : '상점'}</ToggleButton>
                        <ToggleButton variant="light" className="col" value={'R'} onClick={() => { this.udfSelectStdtRuleList('R', null, 'Y') }}>{this.state.usrInfo ? this.state.usrInfo.RED_NM : ' 벌점'}</ToggleButton>
                        <ToggleButton variant="light" className="col" value={'G'} onClick={() => { this.udfSelectStdtRuleList('G', null, 'Y') }}>회복</ToggleButton>
                        <ToggleButton variant="light" className="col" value={'S'} onClick={() => { this.udfSelectStdtRuleList('S', null, 'Y') }}>지도</ToggleButton>
                      </ToggleButtonGroup>
                    </ButtonToolbar>
                  </Form>
                  :
                  <Form className='mt-2 mb-4 searchRuleGu'>
                    <div className="d-flex flex-column">
                      <ButtonToolbar>
                        <ToggleButtonGroup type="radio" name="options1" defaultValue={['RL_DATE']} style={{ width: '100%' }} >
                          <ToggleButton variant="light" className="col" value={'RL_DATE'} onClick={() => { this.udfSelectStdtRuleList(null, 'RL_DATE', 'Y') }}>최신순</ToggleButton>
                          <ToggleButton variant="light" className="col" value={'none'} onClick={() => { this.udfSelectStdtRuleList(null, 'none', 'Y') }}>과거순</ToggleButton>
                        </ToggleButtonGroup>
                      </ButtonToolbar>
                    </div>
                    <ButtonToolbar className="mt-1">
                      <ToggleButtonGroup type="radio" name="options1" defaultValue={['']} style={{ width: '100%' }}>
                        <ToggleButton variant="light" className="col" value={''} onClick={() => { this.udfSelectStdtRuleList('', null, 'Y') }}>전체</ToggleButton>
                        <ToggleButton variant="light" className="col" value={'B'} onClick={() => { this.udfSelectStdtRuleList('B', null, 'Y') }}>{this.state.usrInfo ? this.state.usrInfo.BLUE_NM : '상점'}</ToggleButton>
                        <ToggleButton variant="light" className="col" value={'R'} onClick={() => { this.udfSelectStdtRuleList('R', null, 'Y') }}>{this.state.usrInfo ? this.state.usrInfo.RED_NM : ' 벌점'}</ToggleButton>
                      </ToggleButtonGroup>
                    </ButtonToolbar>
                  </Form>
              }
              {setRuleList}
            </Tab>
            <Tab eventKey='jc' title='지도/상담 >' className="pt-4">{setJcList}</Tab>
            {
              this.state.usrInfo && this.state.usrInfo.RATING_GU !== "Z" ?
                <Tab eventKey='contact' title={'평점 ' + this.state.POINT_RATING + ' >'}>
                  <div className='ratingGuNm'>{this.state.RATING_GU_NM}</div>
                  <ListGroup variant='flush'>
                    <ListGroup.Item>
                      <div className='row'>
                        <div className='col-6'>이월</div>
                        <div className='col-6 text-right'>{this.state.PREV_POINT}</div>
                      </div>
                    </ListGroup.Item>
                    <ListGroup.Item>
                      <div className='row'>
                        <div className='col-6'>{this.state.usrInfo ? this.state.usrInfo.BLUE_NM : '상점'}</div>
                        <div className='col-6 text-right text-primary'>{this.state.POINT_B}</div>
                      </div>
                    </ListGroup.Item>
                    <ListGroup.Item>
                      <div className='row'>
                        <div className='col-6'>{this.state.usrInfo ? this.state.usrInfo.RED_NM : ' 벌점'}</div>
                        <div className='col-6 text-right text-danger'>{this.state.POINT_R}</div>
                      </div>
                    </ListGroup.Item>
                    <ListGroup.Item>
                      <div className='row'>
                        <div className='col-6'>회복</div>
                        <div className='col-6 text-right text-success'>{this.state.POINT_G}</div>
                      </div>
                    </ListGroup.Item>
                    <ListGroup.Item>
                      <div className='row'>
                        <div className='col-6'>지도차감</div>
                        <div className='col-6 text-right'>{this.state.POINT_S}</div>
                      </div>
                    </ListGroup.Item>
                  </ListGroup>
                </Tab>
                : ""
            }
          </Tabs>
        </div>

        {fn_set_footer(this.state.BBS_YN)}
      </>
    );
  }
}

export default RuleListCmp;